const STATS = [
  { value: "50+", label: "agentes de IA implementados" },
  { value: "100%", label: "foco en retorno de inversión" },
  { value: "LATAM", label: "estrategia por industria" },
];

export default function About() {
  return (
    <section
      id="sobre"
      className="reveal"
      style={{
        position: "relative",
        zIndex: 2,
        padding: "100px 28px",
        background: "transparent",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div className="eyebrow" style={{ marginBottom: 24 }}>
          Sobre mí
        </div>

        <div className="about-grid">
          {/* Left — copy */}
          <div>
            <h2
              className="font-display"
              style={{
                fontSize: "clamp(2.2rem, 5vw, 3.8rem)",
                fontWeight: 500,
                letterSpacing: "-0.02em",
                lineHeight: 1.04,
                margin: "0 0 28px",
              }}
            >
              Educador, Consultor y{" "}
              <em style={{ fontStyle: "italic", fontWeight: 400 }}>
                Creador.
              </em>
            </h2>
            <p
              style={{
                fontSize: 16,
                lineHeight: 1.7,
                color: "var(--ink-dim)",
                margin: "0 0 16px",
                maxWidth: 540,
              }}
            >
              Soy un apasionado de la eficiencia y el potencial humano
              amplificado por la tecnología. Mi misión es democratizar el
              acceso a la IA estratégica para el mercado hispano.
            </p>
            <p
              style={{
                fontSize: 16,
                lineHeight: 1.7,
                color: "var(--ink-dim)",
                margin: "0 0 28px",
                maxWidth: 540,
              }}
            >
              No busco implementar tecnología solo porque &quot;está de
              moda&quot;, sino porque resuelve problemas reales: falta de
              tiempo, costes elevados de soporte o cuellos de botella en
              ventas.
            </p>

            <button
              type="button"
              className="btn-primary"
              onClick={(e) => {
                e.preventDefault();
                document
                  .getElementById("contacto")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Trabajemos juntos →
            </button>
          </div>

          {/* Right — stats card */}
          <div
            style={{
              border: "1px solid var(--line)",
              borderRadius: 18,
              padding: "28px 28px 22px",
              background: "rgba(255,255,255,0.32)",
            }}
          >
            <div
              style={{
                fontFamily: "ui-monospace, SFMono-Regular, monospace",
                fontSize: 10,
                color: "var(--ink-mute)",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
                marginBottom: 20,
              }}
            >
              {"// Por los números"}
            </div>

            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              {STATS.map((s, idx) => (
                <li
                  key={s.label}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto 1fr",
                    gap: 22,
                    padding: "20px 0",
                    borderBottom:
                      idx < STATS.length - 1
                        ? "1px solid var(--line)"
                        : "none",
                    alignItems: "baseline",
                  }}
                >
                  <span
                    className="font-display"
                    style={{
                      fontSize: "clamp(2.2rem, 4.4vw, 3.2rem)",
                      fontWeight: 500,
                      letterSpacing: "-0.03em",
                      lineHeight: 0.95,
                      color: "var(--ink)",
                      minWidth: 110,
                    }}
                  >
                    {s.value}
                  </span>
                  <span
                    style={{
                      fontSize: 14,
                      lineHeight: 1.5,
                      color: "var(--ink-dim)",
                    }}
                  >
                    {s.label}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <style>{`
        .about-grid {
          display: grid;
          grid-template-columns: 1fr 1.05fr;
          gap: 56px;
          align-items: start;
        }
        @media (max-width: 880px) {
          .about-grid {
            grid-template-columns: 1fr;
            gap: 36px;
          }
        }
      `}</style>
    </section>
  );
}
